export enum IntegrationURN {
  charliCloudStorage = "activityhandler:v2:internal:charli.ai:internal_cloud_storage",
}
